export const formatSupportPhoneDisplay = (phone?: string | null): string => {
  if (!phone) return '';

  const digits = phone.replace(/\D/g, '');

  if (digits.length === 11 && digits.startsWith('1')) {
    return `1(${digits.slice(1, 4)})-${digits.slice(4, 7)}-${digits.slice(7, 11)}`;
  }

  if (digits.length === 10) {
    return `1(${digits.slice(0, 3)})-${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
  }

  return phone;
};

export const getSupportPhoneHref = (phone?: string | null): string | undefined => {
  if (!phone) return undefined;

  const digits = phone.replace(/\D/g, '');

  if (digits.length === 11 && digits.startsWith('1')) {
    return `tel:+${digits}`;
  }

  if (digits.length === 10) {
    return `tel:+1${digits}`;
  }

  return `tel:${phone}`;
};
